<template>
  <div id="app">
    <div class="container-scroller">
      <!-- IF THERE IS A 500 ERROR SHOW THIS -->
      <div id="application-fault" v-if="application_fault || test.logout">
        <div class="container-fluid page-body-wrapper full-page-wrapper">
          <div
            class="content-wrapper login-wrapper-error d-flex align-items-center auth px-0"
          >
            <div class="row w-100 mx-0">
              <div class="col-lg-4 mx-auto">
                 <div
                    class="card text-left py-5 px-4 px-sm-5"
                  >
                    <div class="card-body">
                      <div class="brand-logo">
                        <img
                          src="@/assets/images/paypredict-logo.svg"
                          alt="PayPredict"
                        />
                      </div>
                      <h2>Oops!</h2>
                      <p>
                        You have been idle for too long, to continue, please
                        reconnect.
                      </p>
                      <div class="pt-3">
                        <button
                          class="btn btn-primary w-100 mt-4 mb-4"
                          @click="GoToLogin()"
                          id="btnConnectWithXeroIdle"
                        >
                          <img
                            src="@/assets/img/xero-logo.png"
                            style="width: 40px"
                            alt="Xero logo"
                          />
                          Connect with Xero
                        </button>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <!-- content-wrapper ends -->
        </div>
      </div>
      <!-- IF THERE IS A 500 ERROR SHOW THIS -->

      <!-- No error, continue with the app -->
      <div v-else>
        <template>
          <!-- Load data - show the spash screen -->
          <Splash v-if="session_dirty" />
          <template v-else>
            <!--
              ##################################################################################
              Login:
            -->
            <div v-if="!logged_in && share_organisation_id == null">
              <div class="container-fluid page-body-wrapper full-page-wrapper">
                <div
                  class="content-wrapper login-wrapper d-flex align-items-center auth px-0"
                >
                  <div class="row w-100 mx-0">
                    <div class="col-lg-4 mx-auto">
                      <div
                        class="card text-left py-5 px-4 px-sm-5"
                      >
                        <div class="brand-logo">
                          <img
                            src="@/assets/images/paypredict-logo.svg"
                            alt="PayPredict"
                          />

                        </div>
                        <!-- <PasswordReset v-if="password_reset" /> -->
                        <div>
                          <div class="pt-3">
                            <ReferLogin />
                        </div>
                        </div>
                      </div>
                      <div class="mt-5 bg-grey px-3 py-2">
                        <p class="text-muted mt-3 subtitle2">
                          By signing in you agree with our
                          <a href="https://evenly.com.au/terms" target="_blank"
                            >Terms and Conditions</a
                          >
                          and
                          <a
                            href="https://evenly.com.au/privacy"
                            target="_blank"
                            >Privacy Policy</a
                          >.
                        </p>
                        <p class="text-muted mt-3 subtitle2">
                          <strong>Problems or Questions?</strong> Drop us an
                          email at
                          <a href="mailto:hello@evenly.com.au"
                            >hello@evenly.com.au</a
                          >
                          and we'll get back to you straight away.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- content-wrapper ends -->
              </div>
            </div>

            <!--
              ##################################################################################
              Signup:
              They have authed with Xero and we need their name and email address
            -->
            <div v-else-if="crisko_user_setup_incomplete && share_organisation_id == null">
              <div class="container-fluid page-body-wrapper full-page-wrapper">
                <div
                  class="content-wrapper login-wrapper-2 d-flex align-items-center auth px-0"
                >
                  <div class="row w-100 mx-0">
                    <div class="col-lg-4 mx-auto">
                      <div
                        class="card text-left py-5 px-4 px-sm-5"
                      >
                        <div class="card-body">
                          <div class="brand-logo">
                            <img
                              src="@/assets/images/paypredict-logo.svg"
                              alt="PayPredict"
                            />
                          </div>
                          <h2>Sign up / Your details</h2>
                          <p>
                            Your name and email matter. <br>
                          </p>
                          <div class="pt-3">
                            <EmailSettings v-bind:submit_action="'add'" />
                          </div>
                        </div>
                        <div class="mt-5 bg-grey px-3 py-2">
                          <p>
                            Your name and email matter, make sure we know who you
                            are and how we can alert you of any customer payment
                            related issues that arise.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- content-wrapper ends -->
              </div>
            </div>
            <!-- They have logged in -->
            <template v-else>
              <!-- If user hasn't selected an org then show the org selector -->

              <div v-if="!is_xero_org_in_url">
               <div class="container-fluid page-body-wrapper full-page-wrapper">
                <div
                  class="content-wrapper login-wrapper-2 d-flex align-items-center auth px-0"
                >
                  <div class="row w-100 mx-0">
                    <div class="col-lg-4 mx-auto">
                      <div
                        class="card text-left py-5 px-4 px-sm-5"
                      >
                        <div class="card-body d-grid gap-2">
                          <div class="brand-logo">
                            <img
                              src="@/assets/images/paypredict-logo.svg"
                              alt="PayPredict"
                            />
                            </div>
                            <OrgSelector  />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- If the organisation hasn't loaded wait before showing the dashboard/other views -->
              <StandBy v-else-if="!org_loading_complete" />
              <AppMain v-else>
                <!-- HEADER if in app -->
                <Header />
                <div class="container page-body-wrapper">
                  <!-- / HEADER -->
                  <router-view />
                </div>
                <!-- FOOTER -->
                <Footer />
                <!-- / FOOTER -->
              </AppMain>
            </template>
          </template>
        </template>
      </div>
    </div>
    <!-- container-scroller ends -->
  </div>
</template>

<script>
import "bootstrap";
import Splash from "./views/Splash.vue"; // Loading data screen
import ReferLogin from "./views/ReferLogin.vue"; // Login for Business, checks for refer id.
import AppMain from "./components/AppMain.vue"; // The main app screen, holds router
import OrgSelector from "./views/OrgSelector.vue"; // The main app screen, holds router
import StandBy from "./views/StandBy.vue";
import EmailSettings from "./views/EmailSettings.vue";

import Header from "./components/layout/Header.vue";
import Footer from "./components/layout/Footer.vue";

export default {
  components: {
    Splash,
    ReferLogin,
    AppMain,
    StandBy,
    OrgSelector,
    Header,
    Footer,
    EmailSettings
  },

  data() {
    return {
      waiting_sync_failures: 0,
      waiting_sync_last_failure: null,
      settings: {
        referral_client_id: null,
      },
      test: {
        logout: false,
      },
      password_reset: false,
    };
  },

  methods: {
    GoToLogin() {
      location.assign("/login/xero");
    },
  },

  computed: {
    application_fault() {
      if (this.$store.state.application_fault) {
        window.console.log("ERROR: " + this.$store.state.application_fault);
      }
      return this.$store.state.application_fault;
    },

    session_dirty() {
      return this.$store.state.session_dirty;
    },
    share_organisation_id() {
      return this.$store.state.share_organisation.xero_authed_organisation_id;
    },

    logged_in() {
      return this.$store.getters.logged_in;
    },

    is_xero_org_in_url() {
      const params = new URLSearchParams(window.location.search)
      return params.get('orgId') != null
    },
    crisko_user_setup_incomplete() {
      return this.$store.getters.crisko_user_setup_incomplete;
    },
    org_loading_complete() {
      return this.$store.getters.org_loading_complete;
    },
    xero_is_connected() {
      return this.$store.getters.xero_is_connected;
    },
    finished_syncing() {
      return this.$store.getters.finished_syncing;
    },

    contacts_report_dirty() {
      return this.$store.state.contacts_report_dirty;
    },

    current_report_id() {
      return this.$store.state.authed_xero.current_report_id;
    },
  },

  watch: {
    $route: {
      handler: (to, from) => {
        document.title = to.meta.title || " - Evenly PayPredict";
      },
      immediate: true,
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch("refresh_session");
    });

    this.$nextTick(() => {
      // Regularly refresh session so know if Xero no longer authenticated
      window.setInterval(() => {
        this.$store.dispatch("refresh_session");
      }, 60 * 1000);
    });

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("orgId") != null && urlParams.get("token") != null) {
      this.$store.dispatch("set_share_organisation");
    } else if (urlParams.get("password_reset_token") != null && urlParams.get("email") != null){
      this.password_reset = true
    }
  },
};
</script>

<style lang="scss">
</style>
